import React, { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Toaster } from "../components/ui/sonner";
import { ListIcon, RobotIcon } from "@phosphor-icons/react";

export const Layout = ({ children, title, subtitle, action }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="App">
      <Sidebar mobileOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      {/* Mobile top bar */}
      <header
        className="sticky top-0 z-30 flex items-center justify-between border-b border-zinc-200 bg-white/95 px-4 py-3 backdrop-blur lg:hidden"
        data-testid="mobile-topbar"
      >
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-sm bg-amber-500 text-zinc-950">
            <RobotIcon size={18} weight="fill" />
          </div>
          <div>
            <p className="font-display text-base font-black uppercase tracking-tight text-zinc-950">
              Megatron
            </p>
          </div>
        </div>
        <button
          onClick={() => setMenuOpen(true)}
          data-testid="mobile-menu-btn"
          className="flex h-10 w-10 items-center justify-center rounded-sm border border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50"
          aria-label="Open menu"
        >
          <ListIcon size={20} weight="bold" />
        </button>
      </header>

      <main className="min-h-screen bg-zinc-50 lg:ml-64">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 sm:py-8 md:px-12 md:py-12">
          <header className="mb-8 flex flex-col gap-4 border-b border-zinc-200 pb-6 md:mb-10 md:pb-8 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-600">
                Megatron / {title}
              </p>
              <h1
                className="mt-2 font-display text-3xl font-black tracking-tighter text-zinc-950 sm:text-4xl md:text-5xl"
                data-testid="page-title"
              >
                {title}
              </h1>
              {subtitle && (
                <p className="mt-2 max-w-2xl text-sm text-zinc-500">{subtitle}</p>
              )}
            </div>
            {action && <div className="flex flex-wrap gap-2">{action}</div>}
          </header>
          {children}
        </div>
      </main>
      <Toaster position="bottom-right" richColors />
    </div>
  );
};
